import type { ConfirmationCodeResult } from './common'

import { nonNullable } from 'lib/array/arrayUtils'
import { getPlural } from 'lib/string/pluralize'
import { useFlightDetailsForItems } from '../api/flights'
import type { FlightItem } from 'tripPlanner/types/tripItem'

export default function useFlightItemConfirmationCodes(
  item: FlightItem,
): ConfirmationCodeResult {
  const { sourceType, confirmationCode, confirmationItemCodes, isBooked } = item
  const isLeBooking = !!(
    sourceType === 'LE_Flight' &&
    isBooked &&
    confirmationCode &&
    confirmationItemCodes &&
    confirmationItemCodes.length > 0
  )

  const {
    data: flightDetails,
    isSuccess,
    isLoading,
  } = useFlightDetailsForItems({
    orderId: confirmationCode!,
    itemIds: confirmationItemCodes,
    enabled: isLeBooking,
  })

  if (isLeBooking) {
    const pnrIds = flightDetails ?
        nonNullable(flightDetails.map((fd) => fd.pnrId)) :
        []

    // This is an LE hotel booking
    if (isSuccess && pnrIds.length > 0) {
      return {
        hasCode: true,
        codes: pnrIds,
        codeString: pnrIds.join(', '),
        label: getPlural('Airline Booking Reference', pnrIds.length),
        isLoading,
      }
    } else {
      return {
        hasCode: false,
        codes: [],
        codeString: '',
        label: 'Airline Booking Reference',
        isLoading,
      }
    }
  } else {
    // This is a custom item or a bookmark
    const confirmationCode = item.confirmationCode
    return {
      hasCode: !!confirmationCode,
      codes: nonNullable([confirmationCode]),
      codeString: confirmationCode,
      label: 'Confirmation number',
      isLoading: false,
    }
  }
}
